export const dispatchResizeEvent = (delayMs: number = 300) => {
    setTimeout(() => {
        window.dispatchEvent(new Event('resize'))
      }, delayMs)
}